import { getLocaleTime } from '../../utils.js'
const fb = require('../../firebaseConfig.js')
const algolia = require('../configs/algoliaConfig.js')

export default {
  state: {
    purchaseOrders: [],
    purchaseOrder: {},
    filters: {},
		// purchaseOrdersPagination: { page: 1, pageSize: 10, lastVisible: null, showLoadMore: true }
		purchaseOrdersPagination: { page: 0, hitsPerPage: 10, totalRecords: 0, totalPages: 0, showLoadMore: true, autoRefresh: false }
  },
  getters: {
    purchaseOrder: (state) => {
      return state.purchaseOrder
    },
    purchaseOrders: (state) => {
      return state.purchaseOrders
    },
    purchaseOrdersPagination: (state) => {
      return state.purchaseOrdersPagination
    },
    filters: (state) => {
      return state.filters
    },
  },
  mutations: {
    setPurchaseOrders(state, val) {
      state.purchaseOrders = val
    },
    setPurchaseOrder(state, val) {
      state.purchaseOrder = val
    },
    setPurchaseOrdersPagination(state, val) {
      state.purchaseOrdersPagination = val
    },
    setFilters(state, val) {
      state.filters = val
    },
    setDefaultPurchaseOrdersPagination(state) {
      // state.purchaseOrdersPagination = { page: 1, pageSize: 10, lastVisible: null, showLoadMore: true };
      state.purchaseOrdersPagination = { page: 0, hitsPerPage: 10, totalRecords: 0, totalPages: 0, showLoadMore: true, autoRefresh: false };
    },
  },
  actions: {
    updatePurchaseOrdersPagination({commit}, data) {
      commit('setPurchaseOrdersPagination', data)
    },
    async fetchBudgetNumber({commit}) {
      console.log("fetchBudgetNumber");
      return await fb.getBudgetNumber().then(response => {
        commit('setBudgetNumber', response.data.budgetNumber);
        // return response.data.budgetNumber;
      });
    },

    async fetchPurchaseOrder({commit}, {purchaseOrderId}) {
        await fb.purchaseOrdersCollection.doc(purchaseOrderId).get().then( async res => {
            let currentPurchaseOrder = res.data()
            currentPurchaseOrder.id = purchaseOrderId
            currentPurchaseOrder.date = getLocaleTime(res.data().date.toDate())

            await fb.providersCollection.doc(currentPurchaseOrder.provider.id).get().then(provider => {
              console.log(provider.data())
              // let materialsUpdated = provider.data().materials
              currentPurchaseOrder.provider.materials = provider.data().materials
              commit('setPurchaseOrder',currentPurchaseOrder)
            })
        })
    },

    async fetchPurchaseOrders({commit, getters}) {
      const index = algolia.client.initIndex(algolia.indexes.purchaseOrders)
      let pagination = getters.purchaseOrdersPagination
      let purchaseOrders = {}
      let filters = getters.filters

      let keywordSearch = ''
      if (filters.keyword != '') {
        keywordSearch = filters.keyword
      }

      index.search(keywordSearch, {page: pagination.page, hitsPerPage: pagination.hitsPerPage}).then(({hits, nbHits, nbPages}) => {
        pagination.totalRecords = nbHits
        pagination.totalPages = nbPages
        pagination.autoRefresh = false

        if (pagination.page == pagination.totalPages-1) {
          pagination.showLoadMore = false
        }

        if (pagination.page == 0) {
          purchaseOrders = hits
        } else {
          purchaseOrders = getters.purchaseOrders.concat(hits)
        }

        commit('setPurchaseOrdersPagination', pagination)
        commit('setPurchaseOrders', purchaseOrders)
      })
    },
    createPurchaseOrder({commit, getters}, payload) {
      commit('setPurchaseOrdersPagination', { page: 1, pageSize: 10, lastVisible: null, showLoadMore: true, autoRefresh: true });
      commit('setPurchaseOrders', []);
      console.log(payload.id)
      if(payload.id) {
        return fb.purchaseOrdersCollection.doc(payload.id).set({
            orderNumber: payload.orderNumber,
            provider: payload.provider,
            status: payload.status,
            products: payload.products,
            costCenter: payload.costCenter,
            total: payload.total,
            subTotal: payload.subTotal,
            tax: payload.tax,
            date: fb.fromDate(payload.date),
            createdOn: fb.fromDate(new Date()),
            createdBy: getters.userId,
            updatedOn: fb.fromDate(new Date()),
            updatedBy: getters.userId,
            timestamp: payload.timestamp || fb.currentTimee()
        })
      }

      return fb.constantsCollection.doc('purchaseOrders').get().then(purchaseOrderConstant => {
        console.log(purchaseOrderConstant.data())
        let purchaseOrderNumber = purchaseOrderConstant.data().value
        fb.constantsCollection.doc('purchaseOrders').set({value: purchaseOrderNumber+1})

        // payload.orderNumber = purchaseOrderNumber
        // commit()

        return fb.purchaseOrdersCollection.add({
            orderNumber: purchaseOrderNumber,
            provider: payload.provider,
            status: payload.status,
            products: payload.products,
            costCenter: payload.costCenter,
            total: payload.total,
            subTotal: payload.subTotal,
            tax: payload.tax,
            date: fb.fromDate(payload.date),
            createdOn: fb.fromDate(new Date()),
            createdBy: getters.userId,
            timestamp: fb.currentTimee(),
          })
      })

    }
  },
}